export function getTransformedEnumObj<T extends Record<string, number | string>>(obj: T) {
  const newObj = new Object()
  for (const key in obj) {
    newObj[key as string] = obj[key]
    newObj[obj[key] as string] = key
  }

  return Object.freeze(newObj) as T & { [P in keyof T as T[P]]: P }
}

export type GetTransformedEnumObjEnumType<T, V> = keyof { [P in keyof T as T[P] extends V ? P : never]: P }
